import React from "react";

const BatchLog = (props) => {
  const { batchLogs } = props;

  return (
    <div className='top-container container-fluid'>
      <h2>バッチログ</h2>
      <table className='table table-condensed table-hover'>
        <thead>
          <tr>
            <th>ID</th>
            <th>クラス</th>
            <th>状態</th>
            <th>開始時刻</th>
            <th>終了時刻</th>
          </tr>
        </thead>
        <tbody>
          {batchLogs.map((batchLog, key) => {
            return (
              <tr key={key}>
                <td>{batchLog.id}</td>
                <td>{batchLog.class_name}</td>
                <td>{batchLog.status}</td>
                <td>{batchLog.started_at}</td>
                <td>{batchLog.finished_at}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default BatchLog;
